import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider as StyledThemePRovider } from 'styled-components';

import typograph from './theme/typograph';
import colors from './theme/colors';
import shadows from './theme/shadows';

const defaultTheme = {
  typograph,
  colors,
  shadows,
};

const ThemeProvider = ({ children }) => (
  <StyledThemePRovider theme={defaultTheme}>
    {children}
  </StyledThemePRovider>
);

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

ThemeProvider.defaultProps = {
  children: null,
};

export default ThemeProvider;
